import React, { useState, useEffect } from 'react';
import { formatUnicorn } from "../../../../shared/utils";
import { useQuery } from '@tanstack/react-query';
import { useCurrentProjectIdContext, useTranslationContext } from "./project-builder-main.jsx";
import { useUpdateProduct } from '../../../components/project-builder-custom-hooks';
import { getProject } from '../../../apis/project-builder';
import Checkbox from '@mui/material/Checkbox';
//import Select from 'react-select';
import toast from '../../../../shared/components/toast';
import NotesModal from './notes-modal.jsx';
import AttachmentsModal from './attachments-modal.jsx';
import AccessoriesModal from './accessories-modal.jsx';
import DeleteModal from './delete-modal.jsx';
import { formatCurrency } from './utilities.jsx';

export default function ProductCard({ isSelectable, isFullWidth, reviewList, readOnly, selectedProductIds, setSelectedProductIds, product, parentId, sortType, isAccessory }) {

    const productId = product.id

    const { currentProjectId } = useCurrentProjectIdContext();

    const { data, isSuccess } = useQuery(['project-detail', currentProjectId], () => getProject(currentProjectId));

    const { mutate: updateProduct, isLoading } = useUpdateProduct(currentProjectId);

    const [isDeleteOpen, setIsDeleteOpen] = useState(false);

    const [quantity, setQuantity] = useState(product.quantity);

    const { translations } = useTranslationContext();

    const handleCheckboxChange = (e) => {
        //const id = e.target.getAttribute('data-id');
        const isChecked = e.target.checked;
        if (isChecked) {
            setSelectedProductIds(selectedProductIds.concat(productId))
        } else {
            setSelectedProductIds(selectedProductIds.filter(x => x !== productId))
        }
    }

    const handleSortOrderValueChange = (event) => {
        let value = event.target.value;
        //if (value < 1) {
        //    toast.error("Product quantity must be at least 1");
        //    return;
        //};

        if (value == product.sortOrder) {
            return;
        }

        updateProduct({
            id: productId,
            sortOrder: value,
        })
    }

    const handleQuantityChange = (event) => {
        let value = event.target.value;
        if (value < 1) {
            toast.error(translations.HandleQunatityErrorMsg);
            return;
        };

        if (value == product.quantity) {
            return;
        }

        updateProduct({
            id: productId,
            quantity: value,
        })

    }

    const openDeleteModal = () => setIsDeleteOpen(true);
    const closeDeleteModal = () => setIsDeleteOpen(false);

    return (
        <>
            <div className={`product-card rounded-border ${isFullWidth ? "product-card--fullWidth" : ""} ${isAccessory ? "product-card--accessory" : null}`}>
                {isAccessory && <div className="product-card-tag"> {translations.Accessory} - {parentId}</div>}
                {isSelectable &&
                    <Checkbox
                        key={productId}
                        className="item-select"
                        onChange={(e) => handleCheckboxChange(e)}
                        checked={selectedProductIds?.includes(productId)}
                        inputProps={{
                            'aria-label': 'Product',
                        }}
                    />
                }

                {(sortType == "Sequence" || sortType == "ProductFamilyGrouping" || sortType == "CustomGrouping") && !readOnly && !isAccessory &&
                    <div className="input-quantity-container sort-value-container">
                        <input className="input-quantity sort-value" type="number" min="0" defaultValue={product.SortOrder} onBlur={handleSortOrderValueChange} />
                    </div>
                }
                <div className="product-card-media">
                    <img src={product.imageUrl ? product.imageUrl : "https://embed.widencdn.net/img/vollrath/j8hhfhfgqr/x300px@2x/PRO_Photo_Missing_glm_11_22.jpeg?q=80"} alt={product.Title} />
                </div>
                <div className="product-card-content">
                    <div className="product-card-sku">{product.sku}</div>
                    <a href={product.url} className="product-card-title" target="_blank">{product.title}</a>

                    <div className="product-card-attributes">

                        {!data.isMarketingProject &&
                            <div className="product-card-price">                          
                                {product.dealerPrice &&
                                    <div style={{ marginTop: '5px' }}>
                                        <span className="product-card-price-label">{translations.Price}</span>
                                        <div>
                                            <span>{formatCurrency(product.dealerPrice, 'es-ES')}</span>
                                        </div>
                                    </div>
                                }

                            </div>
                        }

                        <div className="product-attribute-net condensed-view-only">
                            <span className="product-attribute-label">{translations.NetTotal}</span>
                            <div>{formatCurrency(product.dealerPrice * quantity)}</div>
                        </div>
            
                        <div className="product-attribute-discount condensed-view-only">
                            <span className="product-attribute-label">{translations.YourPrice}</span>
                            <div>{formatCurrency(product.dealerPrice)}</div>
                        </div>

                        {!readOnly
                            ? <>
                                <div style={{ flex: '1', textAlign: 'right', alignSelf: 'flex-end', display: 'flex', alignItems: 'center' }}>
                                    <button className="btn--delete" type="button" onClick={openDeleteModal}>
                                        <span className="icon icon--trash"></span>
                                        <DeleteModal isDeleteOpen={isDeleteOpen} closeDeleteModal={closeDeleteModal} product={product} />
                                    </button>

                                    {!data.isMarketingProject &&
                                        <>
                                            <span style={{ marginRight: '5px' }}>
                                                {translations.Qty}
                                            </span>

                                            <input style={{
                                                borderRadius: '8px',
                                                border: '1px solid #bec3cd',
                                                color: '#5d6677',
                                                maxWidth: '55px',
                                                height: ' 37px',
                                                textAlign: 'center',
                                            }}
                                                type="number" min="1" defaultValue={quantity} onBlur={handleQuantityChange} />
                                        </>
                                    }
                                </div>
                            </>
                            : data.isMarketingProject ? null : <div className="ml-auto rounded-border quantity">{translations.Qty} ({quantity})</div>


                            //? <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', width: '100%' }}>

                            //    <button className="btn--delete" type="button" onClick={openDeleteModal}>
                            //        <span className="icon icon--trash"></span>
                            //        <DeleteModal isDeleteOpen={isDeleteOpen} closeDeleteModal={closeDeleteModal} product={product} />
                            //    </button>
                            //    {!data.isMarketingProject &&
                            //        <>
                            //            <div className="icon icon--edit">Xyz: </div>
                            //            <input className="input-quantity" type="number" min="1" defaultValue={quantity} onBlur={handleQuantityChange} />
                            //        </>
                            //    }
                            //</div>
                            //: data.isMarketingProject ? null : <div className="ml-auto rounded-border quantity">{translations.Qty}: ({quantity})</div>
                        }
                    </div>

                    <div className="product-card-actions">
                        <AttachmentsModal attachments={product.attachments} productNodeId={product.productNodeId} readOnly={readOnly} />
                        <span></span>
                        {!isAccessory &&
                            <>
                                <AccessoriesModal accessories={product.accessories} productNodeId={product.productNodeId} parentProductId={product.id} readOnly={readOnly} />
                            </>
                        }
                        <NotesModal readOnly={readOnly} product={product} />
                    </div>
                </div>
            </div>

        </>

    );
}